module.exports = "/packs/benefits-of-attending-coaching-image-633a14a4bcad6e4ea873991be146f6be.png";